import { Button } from "@/components/clickable";
import { HStack } from "@/components/layout";

export default function Error({
  title,
  description,
  actionText,
  actionHref,

  children,
}) {
  return (
    <HStack className="min-h-screen items-center justify-center">
      <div className="max-w-md rounded-xl border bg-white p-8 shadow-md">
        <div>
          <h1 className="mb-4 text-4xl font-semibold">{title}</h1>
          <p className="mb-4 text-lg">{description}</p>
          {children}
        </div>
        {actionHref && actionText && (
          <HStack className="justify-center">
            <Button href={actionHref}>{actionText}</Button>
          </HStack>
        )}
      </div>
    </HStack>
  );
}
